//TODO Nuxt 3 migration Fix this to use useAuth
export const interceptorOnResponseError = (axios_client) => {
  const interceptorResponseError = async (err) => {
    const { response, config } = err;
    const code = parseInt(response && response.status);
    if (code === 401 && !config.retry) {
      const renewJoinedInflight = isRenewInFlight();
      const pendingRenew = renewSession();
      await trackAuthError('token_invalid', null, undefined, {
        renew_joined_inflight: renewJoinedInflight,
      });
      const result = await pendingRenew;
      if (result.outcome !== 'renewed' && result.outcome !== 'recovered') return Promise.reject(err);
      const token = getToken(config);
      config.headers.Authorization = token;
      axios_client.defaults.headers.Authorization = token;
      config.retry = true;
      return axios_client.request(config);
    }
    return Promise.reject(err);
  };

  return interceptorResponseError;
};

export const interceptorOnResponse = () => {
  return (response) => {
    const { config } = response;
    config.retry = false;
    return response;
  };
};

const getToken = (config) => {
  const isMedia = config.headers.Authorization.includes('Openid');
  const token = `Bearer ${useAuth().idToken.value}`;
  if (isMedia) {
    return token.replace('Bearer', 'Openid');
  }
  return token;
};
